import rfdc from "rfdc";
const clone = rfdc();

/** const myObjectClone = deepCloneObject<MyObjectInterface>(myObject) */
export function deepCloneObject<ObjectType>(object: ObjectType): ObjectType {
  return clone(object);
}
